HTMLFontElement.prototype.replaceData = function replaceData (_0, _1, string) {
  this.parentNode.replaceChild(document.createTextNode(string), this)
}
